import Component from './InDmMedia.vue'
export default Component
export * from './types'
